
import kebabCase from 'lodash.kebabcase';
import type { ClickOrPressEvent } from 'types/mouseEvents';

// *****To update this file see `tools/generate-icon-imports.mjs`*****

import { ReactComponent as Airport01 } from 'assets/icons-duotone/airport-01.svg?react';
import { ReactComponent as Airport02 } from 'assets/icons-duotone/airport-02.svg?react';
import { ReactComponent as Airport03 } from 'assets/icons-duotone/airport-03.svg?react';
import { ReactComponent as Branches } from 'assets/icons-duotone/branches.svg?react';
import { ReactComponent as ClimateChange01 } from 'assets/icons-duotone/climate-change-01.svg?react';
import { ReactComponent as ClimateChange02 } from 'assets/icons-duotone/climate-change-02.svg?react';
import { ReactComponent as Data01 } from 'assets/icons-duotone/data-01.svg?react';
import { ReactComponent as Data02 } from 'assets/icons-duotone/data-02.svg?react';
import { ReactComponent as Data03 } from 'assets/icons-duotone/data-03.svg?react';
import { ReactComponent as Data04 } from 'assets/icons-duotone/data-04.svg?react';
import { ReactComponent as Data05 } from 'assets/icons-duotone/data-05.svg?react';
import { ReactComponent as Digital } from 'assets/icons-duotone/digital.svg?react';
import { ReactComponent as Diversity } from 'assets/icons-duotone/diversity.svg?react';
import { ReactComponent as Education } from 'assets/icons-duotone/education.svg?react';
import { ReactComponent as Electricity } from 'assets/icons-duotone/electricity.svg?react';
import { ReactComponent as Energy } from 'assets/icons-duotone/energy.svg?react';
import { ReactComponent as Gas01 } from 'assets/icons-duotone/gas-01.svg?react';
import { ReactComponent as Gas02 } from 'assets/icons-duotone/gas-02.svg?react';
import { ReactComponent as Global01 } from 'assets/icons-duotone/global-01.svg?react';
import { ReactComponent as Global02 } from 'assets/icons-duotone/global-02.svg?react';
import { ReactComponent as Government } from 'assets/icons-duotone/government.svg?react';
import { ReactComponent as Healthcare } from 'assets/icons-duotone/healthcare.svg?react';
import { ReactComponent as Inclusion01 } from 'assets/icons-duotone/inclusion-01.svg?react';
import { ReactComponent as Inclusion02 } from 'assets/icons-duotone/inclusion-02.svg?react';
import { ReactComponent as Innovation01 } from 'assets/icons-duotone/innovation-01.svg?react';
import { ReactComponent as Innovation02 } from 'assets/icons-duotone/innovation-02.svg?react';
import { ReactComponent as Map } from 'assets/icons-duotone/map.svg?react';
import { ReactComponent as Pipeline01 } from 'assets/icons-duotone/pipeline-01.svg?react';
import { ReactComponent as Pipeline02 } from 'assets/icons-duotone/pipeline-02.svg?react';
import { ReactComponent as Rail } from 'assets/icons-duotone/rail.svg?react';
import { ReactComponent as Road01 } from 'assets/icons-duotone/road-01.svg?react';
import { ReactComponent as Road02 } from 'assets/icons-duotone/road-02.svg?react';
import { ReactComponent as Safety01 } from 'assets/icons-duotone/safety-01.svg?react';
import { ReactComponent as Safety02 } from 'assets/icons-duotone/safety-02.svg?react';
import { ReactComponent as Schedule } from 'assets/icons-duotone/schedule.svg?react';
import { ReactComponent as Seaport01 } from 'assets/icons-duotone/seaport-01.svg?react';
import { ReactComponent as Seaport02 } from 'assets/icons-duotone/seaport-02.svg?react';
import { ReactComponent as Seaport03 } from 'assets/icons-duotone/seaport-03.svg?react';
import { ReactComponent as Seaport04 } from 'assets/icons-duotone/seaport-04.svg?react';
import { ReactComponent as SolarPower01 } from 'assets/icons-duotone/solar-power-01.svg?react';
import { ReactComponent as SolarPower02 } from 'assets/icons-duotone/solar-power-02.svg?react';
import { ReactComponent as StockMarket } from 'assets/icons-duotone/stock-market.svg?react';
import { ReactComponent as Teamwork01 } from 'assets/icons-duotone/teamwork-01.svg?react';
import { ReactComponent as Teamwork02 } from 'assets/icons-duotone/teamwork-02.svg?react';
import { ReactComponent as Terminal } from 'assets/icons-duotone/terminal.svg?react';
import { ReactComponent as TollRoad01 } from 'assets/icons-duotone/toll-road-01.svg?react';
import { ReactComponent as TollRoad02 } from 'assets/icons-duotone/toll-road-02.svg?react';
import { ReactComponent as Transportation } from 'assets/icons-duotone/transportation.svg?react';
import { ReactComponent as Water01 } from 'assets/icons-duotone/water-01.svg?react';
import { ReactComponent as Water02 } from 'assets/icons-duotone/water-02.svg?react';
import { ReactComponent as WindPower01 } from 'assets/icons-duotone/wind-power-01.svg?react';
import { ReactComponent as WindPower02 } from 'assets/icons-duotone/wind-power-02.svg?react';

export type IconString =

| 'airport-01'
| 'airport-02'
| 'airport-03'
| 'branches'
| 'climate-change-01'
| 'climate-change-02'
| 'data-01'
| 'data-02'
| 'data-03'
| 'data-04'
| 'data-05'
| 'digital'
| 'diversity'
| 'education'
| 'electricity'
| 'energy'
| 'gas-01'
| 'gas-02'
| 'global-01'
| 'global-02'
| 'government'
| 'healthcare'
| 'inclusion-01'
| 'inclusion-02'
| 'innovation-01'
| 'innovation-02'
| 'map'
| 'pipeline-01'
| 'pipeline-02'
| 'rail'
| 'road-01'
| 'road-02'
| 'safety-01'
| 'safety-02'
| 'schedule'
| 'seaport-01'
| 'seaport-02'
| 'seaport-03'
| 'seaport-04'
| 'solar-power-01'
| 'solar-power-02'
| 'stock-market'
| 'teamwork-01'
| 'teamwork-02'
| 'terminal'
| 'toll-road-01'
| 'toll-road-02'
| 'transportation'
| 'water-01'
| 'water-02'
| 'wind-power-01'
| 'wind-power-02';

export type IconSVG = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
export const allIconComponents: Record<IconString, IconSVG> = {
    'airport-01': Airport01,
    'airport-02': Airport02,
    'airport-03': Airport03,
    branches: Branches,
    'climate-change-01': ClimateChange01,
    'climate-change-02': ClimateChange02,
    'data-01': Data01,
    'data-02': Data02,
    'data-03': Data03,
    'data-04': Data04,
    'data-05': Data05,
    digital: Digital,
    diversity: Diversity,
    education: Education,
    electricity: Electricity,
    energy: Energy,
    'gas-01': Gas01,
    'gas-02': Gas02,
    'global-01': Global01,
    'global-02': Global02,
    government: Government,
    healthcare: Healthcare,
    'inclusion-01': Inclusion01,
    'inclusion-02': Inclusion02,
    'innovation-01': Innovation01,
    'innovation-02': Innovation02,
    map: Map,
    'pipeline-01': Pipeline01,
    'pipeline-02': Pipeline02,
    rail: Rail,
    'road-01': Road01,
    'road-02': Road02,
    'safety-01': Safety01,
    'safety-02': Safety02,
    schedule: Schedule,
    'seaport-01': Seaport01,
    'seaport-02': Seaport02,
    'seaport-03': Seaport03,
    'seaport-04': Seaport04,
    'solar-power-01': SolarPower01,
    'solar-power-02': SolarPower02,
    'stock-market': StockMarket,
    'teamwork-01': Teamwork01,
    'teamwork-02': Teamwork02,
    terminal: Terminal,
    'toll-road-01': TollRoad01,
    'toll-road-02': TollRoad02,
    transportation: Transportation,
    'water-01': Water01,
    'water-02': Water02,
    'wind-power-01': WindPower01,
    'wind-power-02': WindPower02,
};

interface IconProps {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    icon: IconString | string;
    className?: string;
    // eslint-disable-next-line no-unused-vars
    onClick?: (event: ClickOrPressEvent) => void;
}

const Icon: React.FC<IconProps> = props => {
    const { icon, className, onClick } = props;
    const iconName = kebabCase(icon) as IconString;
    const SpecificIcon = allIconComponents[iconName];

    if (!SpecificIcon) {
        return null;
    }

    const isClickableClass = onClick ? 'svg-icon-clickable' : '';

    const iconClass = `svg-icon ${isClickableClass} ${className ? className : ''}`;

    return <SpecificIcon onClick={onClick} className={iconClass} />;
};

export default Icon;
